<template>
  <Modal v-model="showModal" :title="title" :footer-hide="true" width="600" class="top">
    <Form :model="formData" ref="formRef" :label-width="80" class="form" v-if="showForm">
      <FormItem label="归属分类" class="less" prop="courseColumns" key="courseColumns" :rules="$units.formRule.arrRequired('请选择分类', 'change')">
        <selectTree
          :data="columnList"
          :multiple="true"
          :size="null"
          placeholder="请选择"
          :single="true"
          :showParentNode="true"
          :selectAllChildren="false"
          @onChange="columnChange"
          v-model="formData.courseColumns"
        ></selectTree>
      </FormItem>

      <FormItem label="展示机构" prop="organIds" :rules="$units.formRule.required('请选择机构', (trigger = 'change'), (type = 'array'))" class="full">
        <selectTreeNew v-model="formData.organIds" :multiple="true" type="4" ref="selectTreeRef" @getTreeData="getTreeData"></selectTreeNew>
      </FormItem>
    </Form>

    <div class="ivu-modal-footer">
      <Button type="text" @click="showModal = false">取消</Button>
      <Button type="primary" @click="confirm" :loading="loading">确认</Button>
    </div>
  </Modal>
</template>

<script>
import selectTreeNew from '@/components/system/selectTree3';
import selectTree from '@/components/commons/selectTree';
export default {
  components: {
    selectTreeNew,
    selectTree
  },
  data() {
    return {
      showModal: false,
      showForm: false,
      columnList: [],
      title: '',
      formData: {},
      selseArr: [],
      isUse: null,
      selectAll: null,
      articleQuery: {},
      loading: false
    };
  },

  methods: {
    open(selseArr, isUse, isAll, searchObj) {
      this.articleQuery = searchObj;
      this.selectAll = isAll;
      this.showModal = true;
      this.showForm = true;
      this.isUse = isUse;
      this.selseArr = selseArr;
      this.title = `即将导入${selseArr.length}篇课程，请选择`;
      this.getColumnList();
      this.$nextTick(() => {
        this.$refs.selectTreeRef && this.$refs.selectTreeRef.openChange(true);
      });
      this.formData = {
        organIds: []
      };
    },

    // 获取树节点id
    getTreeData(data) {
      this.depData(data);
      this.$nextTick(() => {
        this.$refs.selectTreeRef.setSelectIdByChecked();
      });
    },
    depData(data) {
      data.forEach(item => {
        this.$set(item, 'checked', true);
        item.children.length ? this.depData(item.children) : [];
      });
    },

    // 分类
    getColumnList() {
      this.$http({
        url: '/buz/courseColumn/read/list',
        type: 'POST',
        data: {}
      }).then(res => {
        this.columnList = this.dealTree(res.data);
      });
    },
    dealTree(arr) {
      return arr.map(item => ({
        ...item,
        value: item.id,
        label: item.name,
        title: item.name,
        expand: true,
        children: item.children && item.children.length > 0 ? this.dealTree(item.children, item.name) : null
      }));
    },

    columnChange(name, ids) {
      this.$set(this.formData, 'courseColumns', ids);
    },

    confirm() {
      this.$refs['formRef'].validate(valid => {
        if (valid) {
          if (this.loading) {
            return;
          }
          this.loading = true;
          let data = {
            sourceIds: this.selseArr,
            organIds: this.formData.organIds,
            courseColumns: this.formData.courseColumns,
            isUse: this.isUse,
            articleQuery: this.articleQuery
          };
          if (this.selectAll) {
            data.selectAll = true;
            delete data.sourceIds;
          } else {
            data.selectAll = false;
          }
          this.$http({
            url: `/buz/course/source/pick`,
            type: 'POST',
            data
          }).then(res => {
            this.$Message.success('操作成功');
            this.showModal = false;
            this.$emit('reload');
            setTimeout(() => {
              this.loading = false;
            }, 300);
          });
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
/deep/ .ivu-modal-header {
  height: 40px;
  padding-left: 20px !important;
}
/deep/ .ivu-modal-header-inner {
  font-size: 14px !important;
}
/deep/ .ivu-modal-close .ivu-icon-ios-close {
  font-size: 34px;
}
</style>
